/* __next_internal_client_entry_do_not_use__ HeaderOpenWithFaire auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TopOfPageContentWrapper } from "@faire/retailer-visitor-shared/components/App/TopOfPageContent/Wrapper";
import { LoginSection } from "@faire/retailer-visitor-shared/components/Header/desktop/LoginSection";
import { HeaderCart } from "@faire/retailer-visitor-shared/components/Header/HeaderCart";
import { OpenWithFaireBreadcrumbs } from "@faire/retailer-visitor-shared/components/Header/HeaderOpenWithFaire/__internal__/OpenWithFaireBreadcrumbs";
import { HeaderStoreProvider } from "@faire/retailer-visitor-shared/components/Header/HeaderStoreProvider";
import { HeaderMobileSignUp } from "@faire/retailer-visitor-shared/components/Header/mobile/HeaderMobileSignUp";
import { HeaderContainer } from "@faire/retailer-visitor-shared/components/Header/styled";
import { canAddToCart } from "@faire/retailer-visitor-shared/lib/canAddToCart";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var HeaderOpenWithFaireBase = function() {
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    return /*#__PURE__*/ _jsx(TopOfPageContentWrapper, {
        children: /*#__PURE__*/ _jsx(HeaderContainer, {
            children: /*#__PURE__*/ _jsx(Wrapper, {
                children: /*#__PURE__*/ _jsxs(HeaderStoreProvider, {
                    children: [
                        /*#__PURE__*/ _jsx(OpenWithFaireBreadcrumbs, {}),
                        /*#__PURE__*/ _jsxs(HeaderItems, {
                            align: "center",
                            children: [
                                isDesktopAndAbove ? /*#__PURE__*/ _jsx(LoginSection, {}) : /*#__PURE__*/ _jsx(HeaderMobileSignUp, {}),
                                /*#__PURE__*/ _jsx(CartSection, {})
                            ]
                        })
                    ]
                })
            })
        })
    });
};
export var HeaderOpenWithFaire = observer(HeaderOpenWithFaireBase);
var CartSection = /*#__PURE__*/ React.memo(function() {
    return canAddToCart() ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HeaderCart, {
                dataTestId: "headerCartButton"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "3x"
            })
        ]
    }) : null;
});
var Wrapper = styled(Row).attrs({
    justify: "space-between"
}).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-ff2c383b-0"
})([
    "width:100%;"
]);
var HeaderItems = styled(Row).withConfig({
    componentId: "sc-ff2c383b-1"
})([
    "min-height:60px;"
]);
